import { defineStore } from 'pinia'
import { useflightPlanState } from './flightPlanState'
import { watch } from 'vue'
export const useFlightRouteModalState = defineStore('modal', {
  state: () => ({
    modalForm: {
      routeName: '',
      airCraft: '',
      payLoad: '',
      routeType: ''
    },
    orthoSettings: {
      gsd: 0,
      altitudeMode: 'agl',
      routeAltitude: 200,
      safeTakeoffAltitude: 20,
      speed: 0,
      courseAngle: 0,
      elevationOptimization: true,
      uponCompletion: 'return',
    },
    advancedSettings: {
      cameraTrigger: 30,
      maxFlightTime: 25,
      tstp: 0.0,
      sideOverlap: 75,
      frontalOverlap: 80,
      margin: 0,
      photoMode: 'timed',
      takeoffSpeed: 15,
      customCamera: true
    },
  }),

  actions: {
    setModalForm (form) {
      this.modalForm = form
    },
    setOrthoSettings (orthoSettings) {
      this.orthoSettings = orthoSettings
    },
    setAdvancedSettings (advancedSettings) {
      this.advancedSettings = advancedSettings
    },
    initSync () {
      const flightPlanStore = useflightPlanState()
      watch(
        () => flightPlanStore.flightPlan?.flightPlan?.parameters?.gsd,
        (newGsd) => {
          this.orthoSettings.gsd = newGsd
        },
        { immediate: true }
      )
    }
  }
})
